
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'

import FontAwesome from 'react-fontawesome'
import EmployeePage from './EmployeePage'


class EmployeeModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

    //this.openPopup() 
  }

  openPopup(){
    console.log("ref",this.refs.swtCustPop)
    //this.refs.swtCustPage.loadPage()
  }

  onSelectCustomerItem(item){
    if(typeof this.props.onSelect !=='undefined'){
      this.props.onSelect(item)
    }else{
      window.onSelectCustomerItem(item)
    }
    this.props.onHide()
  }

  render(){
    let {show,showNew} = this.props
    
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'ค้นหาช่างภายในบริษัท'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EmployeePage ref={'swtCustPage'} showNew={showNew} onSelectItem={this.onSelectCustomerItem.bind(this)}/>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default EmployeeModal;





// WEBPACK FOOTER //
// ./src/view/hr/EmployeeModal.js